import React from 'react';
import clsx from 'clsx';
import { LIST_FILTER_SELECT_CLASS } from '../../utils/listPageUi';

/**
 * Compact dropdown filter (replaces pill/chip filter rows).
 * options: { id, name, count? }[]
 */
const FilterSelect = ({
  id,
  label,
  value,
  onChange,
  options,
  disabled = false,
  className,
  hideLabel = false,
}) => {
  const selectId = id || `filter-${String(label || 'select').replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div className={clsx('min-w-0 shrink-0', className)}>
      {label && !hideLabel ? (
        <label
          htmlFor={selectId}
          className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400"
        >
          {label}
        </label>
      ) : null}
      <div className="relative w-full">
        <select
          id={selectId}
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          aria-label={hideLabel && label ? label : undefined}
          className={clsx(
            LIST_FILTER_SELECT_CLASS,
            'filter-select',
            disabled && 'cursor-not-allowed opacity-50'
          )}
        >
          {options.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.name}
              {opt.count != null ? ` (${opt.count})` : ''}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FilterSelect;
